module.exports = __webpack_public_path__ + "images/help_v2/video-calendar-5f47081e239bde4f52068870761f6ccd.jpg";